import { render, staticRenderFns } from "./topupBillsPayment.vue?vue&type=template&id=ca94ebd2"
import script from "./topupBillsPayment.vue?vue&type=script&lang=js"
export * from "./topupBillsPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports